import Vue from 'vue'
import VueRes from 'vue-resource'
import VueCook from 'vue-cookie'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
// import locale from 'element-ui/lib/locale/lang/fr'
import locale from '../public/assets/element-ui/fr'

import '../public/assets/element-ui/theme/index.css'

Vue.config.productionTip = false
Vue.use(VueRes)
Vue.http.options.credentials = true
Vue.use(VueCook)
Vue.use(ElementUI, {locale})
Vue.use(HighchartsVue)

Highcharts.setOptions({
    colors: ['#7cb5ec', '#f7a35c', '#90ee7e', '#7798BF', '#aaeeee', '#ff0066', '#eeaaee',
        '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
    chart: {
        backgroundColor: null,
        style: {
            fontFamily: 'Roboto, Arial, sans-serif'
        }
    },
    title: {
        style: {
            fontSize: '16px',
            fontWeight: 'bold',
            textTransform: 'uppercase'
        }
    },
    tooltip: {
        borderWidth: 0,
        backgroundColor: 'rgba(219,219,216,0.8)',
        shadow: false
    },
    legend: {
        itemStyle: {
            fontWeight: 'bold',
            fontSize: '13px'
        }
    },
    xAxis: {
        gridLineWidth: 1,
        labels: {
            style: {
                fontSize: '12px'
            }
        }
    },
    yAxis: {
        minorTickInterval: 'auto',
        title: {
            style: {
                textTransform: 'uppercase'
            }
        },
        labels: {
            style: {
                fontSize: '12px'
            }
        }
    },
    plotOptions: {
        candlestick: {
            lineColor: '#404048'
        }
    },
    // General
    background2: '#F0F0EA',
    credits: {
        enabled: false
    }
})

// Vue.http.options.xhr = { credentials: true }
// Vue.http.options.emulateJSON = true

Vue.filter('format_date', function(input){
    let date = new Date(input)
    return date.toLocaleDateString()
})

Vue.http.interceptors.push(function(request) {
    // console.log('interceptor', Vue.cookie.get('csrftoken'), request)
    // console.log('interceptor', Vue.cookie.get('csrftoken_dj'))
    // console.log('interceptor', request.method)
    // console.log('interceptor', ['POST', 'PUT'].indexOf(request.method))
    if(['POST', 'PUT'].indexOf(request.method) >= 0 ){
        request.headers.set('X-CSRFToken', Vue.cookie.get('csrftoken_dj'));
        // console.log('INSIDE POST PUT', request)
    }

    return function(response) {
        // console.log('interceptor response', response)
        if(response.ok == false) {
            // console.log('interceptor response', response)
            if(response.status == 403 && response.body == "not_authenticated"){
                Vue.prototype.$notify.error({
                    title:"Vous n'êtes plus authentifié⋅e",
                    message:"Vous allez être redirigé⋅e vers la page de connexion",
                    duration:3000,
                    offset:100
                })
                store.commit("logout")
                setTimeout(function(){
                    router.push({name: 'login'})
                    .catch(function(err){})
                }, 3000)
            } else if(response.status == 0) {
                router.push({name: 'dashboard'})
            } else {
                var first_index = response.bodyText.indexOf('Request Method:')
                var last_index = response.bodyText.indexOf('Python Executable:')
                var error = ''
                var message = ''
                if(first_index > 0 && last_index > first_index){
                    error = response.bodyText.slice(first_index, last_index).replaceAll(/<.+?>/g, '')
                }
                if(error.length > 0){
                    message = error
                } else {
                    message = "_URL : "+response.url+"  _Code erreur : "+response.status+" -> "+response.statusText
                }
                Vue.prototype.$notify.error({
                    title:"Une erreur est survenue",
                    message:message,
                    duration:5000,
                    offset:100
                })
            }
        }else if(response.body && response.body.status == "functionalError"){
            // Vue.prototype.$notify.error({
            //     title: response.body.title,
            //     message: response.body.message,
            //     duration:5000,
            //     offset:100
            // })

            Vue.prototype.$msgbox({
                type: "error",
                title: response.body.title,
                message: response.body.message,
                confirmButtonText: 'OK',
            })
        }
    }
})



new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
